import type { IconNode } from '../types';

/**
 * @name shield-house
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMjJhMSAxIDAgMDEtMS0xdi00YTEgMSAwIDAxLjQ0NS0uODMybDMtMmExIDEgMCAwMTEuMTEgMGwzIDJBMSAxIDAgMDEyMiAxN3Y0YTEgMSAwIDAxLTEgMXoiIC8+CiAgPHBhdGggZD0iTTE4IDIydi0zIiAvPgogIDxwYXRoIGQ9Ik0yMCAxMC40MThWNmExIDEgMCAwMC0xLTFjLTIgMC00LjQ5LTEuMTktNi4yNC0yLjcyYTEuMTcgMS4xNyAwIDAwLTEuNTIgMEM5LjUgMy44IDcgNSA1IDVhMSAxIDAgMDAtMSAxdjdjMCA0LjYwMiAyLjY3IDcuMSA2LjAzNyA4LjYwMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/shield-house
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ShieldHouse: IconNode = [
  [
    'path',
    {
      d: 'M15 22a1 1 0 01-1-1v-4a1 1 0 01.445-.832l3-2a1 1 0 011.11 0l3 2A1 1 0 0122 17v4a1 1 0 01-1 1z',
    },
  ],
  ['path', { d: 'M18 22v-3' }],
  [
    'path',
    {
      d: 'M20 10.418V6a1 1 0 00-1-1c-2 0-4.49-1.19-6.24-2.72a1.17 1.17 0 00-1.52 0C9.5 3.8 7 5 5 5a1 1 0 00-1 1v7c0 4.602 2.67 7.1 6.037 8.603',
    },
  ],
];

export default ShieldHouse;
